import { 
    Button, 
    faArrowLeftRotate, 
    FontAwesomeIcon, 
    HashLink, 
    useMediaQuery
} from "../../../../Constants/libraries"
import { 
    title,
    content_first_title,
    content_first_p1,  
    content_first_p2,
    content_second_title,
    content_second_p1,
    content_second_p2,
    content_third_title,
    content_third_p1,
    content_third_p2,
    content_third_bullets,
    content_fourth_title,
    content_fourth_bullets
} from "./Constants"
import { CTA } from "../../../CTA/CTA"

import "../../ServicesSubpages.css"

export const CompanyIncorporation = () => {

    const tablet = useMediaQuery({ query: '(max-width: 780px)' })
    const background = tablet ? "https://smscs-frontend.s3.ap-southeast-1.amazonaws.com/Services/Services_All_Thumbnails_Resized/services_building.jpg" : "https://smscs-frontend.s3.ap-southeast-1.amazonaws.com/Services/Services_All_Thumbnail_Backgrounds/services_building_background.jpg"
    
    return (
        <>
            <div 
                id=">"
                className="CompanyIncorporation Services__Subpage"
                style={{
                    background: "#000000",
                    backgroundImage: `url(${background})`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                }}
            >
                <div className="Services__Subpage__Overlay"></div>

                <div className="Services__Subpage__Overlay-cancel">

                    {/* Content */}
                    {!tablet && 
                        <div className="Services__Subpage__Content">
                            <h1>{content_first_title}</h1>
                            <p>{content_first_p1}</p>
                            <p>{content_first_p2}</p>
                            <hr />

                            <h1>{content_second_title}</h1>
                            <p>{content_second_p1}</p>
                            <p>{content_second_p2}</p>
                            <hr />

                            <h1>{content_third_title}</h1>
                            <ul>
                                {content_third_bullets.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                            <p>{content_third_p1}</p>
                            <p>{content_third_p2}</p>
                            <hr />

                            <h1>{content_fourth_title}</h1>
                            <ul>
                                {content_fourth_bullets.map((item, index) => (
                                    <li key={index}>{item}</li>
                                ))}
                            </ul>
                            <hr />
                        </div>
                    }

                    {/* Empty div for flexbox */}
                    <div className="Services__Subpage__Content-flex">
                        <p>{title}</p>
                        <Button>
                            <HashLink smooth to="/services#>">
                                <span><FontAwesomeIcon icon={faArrowLeftRotate}/></span>
                                SERVICES
                            </HashLink>
                        </Button>
                    </div>
                </div>
            </div>

            {/* Content layout for mobile */}
            {tablet && 
                <div className="Services__Subpage__Content">
                    <h1>{content_first_title}</h1>
                    <p>{content_first_p1}</p>
                    <p>{content_first_p2}</p>
                    <hr />

                    <h1>{content_second_title}</h1>
                    <p>{content_second_p1}</p>
                    <p>{content_second_p2}</p>
                    <hr />

                    <h1>{content_third_title}</h1>
                    <ul>
                        {content_third_bullets.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                    <p>{content_third_p1}</p>
                    <p>{content_third_p2}</p>
                    <hr />

                    <h1>{content_fourth_title}</h1>
                    <ul>
                        {content_fourth_bullets.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                    <hr />
                </div>
            }

            {/* CTA */}
            <CTA />
        </>
    )
}